import compose from 'lodash/fp/compose';

import { canAdd, canDelete, canUpdate, paginate } from '../plugins';
import classesApi from '../../firebase/classes';
import PluggableModule from '../pluggable';

const classes = new PluggableModule('class', 'classes');

const ucName = classes.name.toUpperCase();
const GET_INIT = `${ucName}_GET_SCHEDULED_INIT`;
const GET_ERROR = `${ucName}_GET_SCHEDULED_ERROR`;
const GET_DONE = `${ucName}_GET_SCHEDULED_DONE`;
classes.addMutationTypes([GET_INIT, GET_ERROR, GET_DONE]);

classes.extend({
  namespaced: true,
  state: {
    latestClass: [],
    loadingLatestClass: false,
    loadLatestClassError: null
  },
  mutations: {
    [GET_INIT](state) {
      state.loadingLatestClass = true;
      state.loadLatestClassError = null;
    },
    [GET_DONE](state, data) {
      state.loadingLatestClass = false;
    },
    [GET_ERROR](state, error) {
      state.loadLatestClassError = error;
      state.loadingLatestClass = false;
    }
  },
  actions: {
    async addClass({ commit }, args) {
      commit(classes.con.CLASS_SUBMIT_INIT);
      try {
        const ref = await classesApi.add(args);
        commit(classes.con.CLASS_SUBMIT_DONE);
      } catch (error) {
        commit(classes.con.CLASS_SUBMIT_DONE);
        throw error;
      }
    },
    async updateClass({ commit }, args) {
      commit(classes.con.CLASS_SUBMIT_INIT);
      try {
        const ref = await classesApi.update(args);
        commit(classes.con.CLASS_SUBMIT_DONE);
      } catch (error) {
        commit(classes.con.CLASS_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  canDelete(classesApi.delete),
  paginate('classes', {
    filterDefinition: {
      user: 'reference',
      scheduledAt: 'orderBy'
    },
    filterDefault: {
      scheduledAt: 'desc'
    },
    // TODO:
    pageSize: 50
  })
);
export default hop(classes);
